export const MONTH: { [key: number]: string } = {
  1: 'Enero',
  2: 'Febrero',
  3: 'Marzo',
  4: 'Abril',
  5: 'Mayo',
  6: 'Junio',
  7: 'Julio',
  8: 'Agosto',
  9: 'Septiembre',
  10: 'Octubre',
  11: 'Noviembre',
  12: 'Diciembre',
}

export const YEARS: { [key: number]: string } = {}

for (let i = 0; i < 3; i++) {
  const year = new Date().getFullYear() - i
  YEARS[year] = year.toString()
}
